import React, {ReactNode} from 'react';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import {useSettingsContext} from './context/settings/useSettingsContext';

type TProps = {
    children: ReactNode;
}

const ConditionalReCaptchaProvider: React.FC<TProps> = ({ children }) => {
    const {
        useGoogleRecaptchaV3,
        useGoogleRecaptchaV3Enterprise,
        googleRecaptchaV3PublicKey,
    } = useSettingsContext();

    return useGoogleRecaptchaV3 && googleRecaptchaV3PublicKey ? (
        <GoogleReCaptchaProvider
            useEnterprise={useGoogleRecaptchaV3Enterprise}
            useRecaptchaNet
            reCaptchaKey={googleRecaptchaV3PublicKey}
            scriptProps={{ async: true, defer: true, appendTo: 'body' }}
        >
            {children}
        </GoogleReCaptchaProvider>
    ) : (
        <>{children}</>
    );
};

export default ConditionalReCaptchaProvider;
